// Door open/close control shown only for aero-type robots; returns null otherwise.
import React from "react";
import { Box, Stack, Avatar, Typography, Button } from "@mui/material";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import PropTypes from "prop-types";
import { tokens } from "../../theme";

const DoorControl = ({ isDoorOpen, onDoorPress, isAeroRobot }) => {
  if (!isAeroRobot) return null;

  return (
    <Box
      sx={{
        p: 1.75,
        background: isDoorOpen ? tokens.successSoft : tokens.surface2,
        border: `1px solid ${isDoorOpen ? tokens.success : tokens.border}`,
        borderRadius: "12px",
      }}
    >
      <Stack direction="row" alignItems="center" gap={1.5}>
        {/* Door status icon */}
        <Avatar
          sx={{
            width: 40,
            height: 40,
            borderRadius: "11px",
            flexShrink: 0,
            background: isDoorOpen ? tokens.success : tokens.accent,
          }}
        >
          <MeetingRoomIcon sx={{ fontSize: 20, color: "#fff" }} />
        </Avatar>

        {/* Labels + status pill */}
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack direction="row" alignItems="center" gap={0.75}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: tokens.text }}>
              {isDoorOpen ? "Door is Open" : "Door is Closed"}
            </Typography>
            <Stack
              direction="row"
              alignItems="center"
              gap={0.5}
              sx={{
                px: 0.9,
                py: 0.15,
                borderRadius: "999px",
                background: isDoorOpen ? tokens.successSoft : tokens.surface,
                border: `1px solid ${isDoorOpen ? tokens.success : tokens.border}`,
              }}
            >
              <FiberManualRecordIcon
                sx={{ fontSize: 7, color: isDoorOpen ? tokens.success : tokens.text3 }}
              />
              <Typography
                sx={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: isDoorOpen ? tokens.success : tokens.text3,
                }}
              >
                {isDoorOpen ? "Open" : "Closed"}
              </Typography>
            </Stack>
          </Stack>
          <Typography sx={{ fontSize: 11, color: tokens.text2, mt: 0.2 }}>
            {isDoorOpen ? "Compartment is accessible" : "Press to open the delivery compartment"}
          </Typography>
        </Box>

        {/* Toggle button */}
        <Button
          size="small"
          variant="contained"
          onClick={onDoorPress}
          sx={{
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: 12,
            boxShadow: "none",
            px: 1.75,
            flexShrink: 0,
            color: "#fff",
            background: isDoorOpen ? tokens.danger : tokens.accent,
            "&:hover": {
              background: isDoorOpen ? tokens.danger : tokens.accent,
              filter: "brightness(1.06)",
              boxShadow: "none",
            },
          }}
        >
          {isDoorOpen ? "Close Door" : "Open Door"}
        </Button>
      </Stack>
    </Box>
  );
};

DoorControl.propTypes = {
  isDoorOpen: PropTypes.bool,
  onDoorPress: PropTypes.func,
  isAeroRobot: PropTypes.bool,
};

export default DoorControl;
